import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import LogoutModal from "../../components/LogoutModal/LogoutModal.component";

function BottomPanel() {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = React.useState(false);
  const { t } = useTranslation();
  const notificationsOpen = useSelector(
    (state) => state.layout.notificationsOpen
  );

  const handleClickOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="mt-auto">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div 
                className="w-full h-[70px] flex justify-center items-center cursor-pointer hover:bg-blue-700 transition-colors"
                onClick={handleClickOpen}
              >
                <LogOut className="w-6 h-6 text-white rotate-180" />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p>{t("dashboard.drawer.logout")}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      {/* logout modal */}
      <LogoutModal modalOpen={modalOpen} handleClose={handleClose} />
    </>
  );
}

export default BottomPanel;
